<template>
    <div id="Lease_DashBoard">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template>
                <div class="page-name">
                    <span class="page-title" id="dashboard">Work Queue</span>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content dashboard-page">
                        <section class="internal-container border-top-table-fl">
                            <div class="form-row row-cols-md-4">
                                <div class="col form-group">
                                    <label class="control-label" for="state">Location:</label>
                                    <v-select v-model="location_id" name="location_id" placeholder="Select Location." label="text" class='close-remove' :options="locationArr" @input="onLocationChange">
                                    </v-select>
                                </div>
                            </div>
                            <div>
                                <asset-analytics id="asset-analytics" :fromModule="location_id" ref="loadassetanalytics"/>
                            </div>
                        </section>
                    </div>
                </div>
            </template>
            <!-- <template v-else>
                <loading-content></loading-content>
            </template> -->
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';
import {contractMixins} from '../mixins/contractMixins';

import AssetAnalytics from '@/components/dashboard/AssetAnalytics.vue';
Vue.component("asset-analytics", AssetAnalytics);

export default {
    name: "DashBoard",
    
    mixins:[commonMixins,contractMixins],
    data: () => ({
        permissions: [],
        cantAccessPage: true,
        loading:false,
       
        canViewWoOndashBoard:false,
        canViewfuelList:false,
        waitEndForFuelDrop:false,
        loadReservationList:false,
        loadWorkorderlist:false,
        location_id: null,
        locationArr: [],
    }),
    watch:{

            //check permission change
            permissions: function (permissions) {

                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        // if (permissions[i].name == 'dashboard') {
                        //     self.cantAccessPage = true;
                        // }
                    }
                }

            }
    },
    created: function() {

    },
    mounted: function() {
            var self = this;
            self.getPermissions();
            self.loadFieldData(['location']);
            var userObj = localStorage.getItem("user_obj");
            //if user logged in than remove login button and registration button
            if ( userObj != null ) {
                var userJson = JSON.parse(userObj);
                if(userJson && userJson.location_id != null && userJson.location_id  != ''){
                    self.location_id = {value: userJson.location_id, text: self.titleCase(userJson.locationName) };
                }
            }
    },
    methods: {
        onLocationChange(evt){
            var self = this;
            self.location_id = {value: evt.value, text: self.titleCase(evt.text) };
            self.$refs.loadassetanalytics.location_id =self.location_id;
        },
    }
};
</script>




// WEBPACK FOOTER //
// src/components/LeaseDashboard.vue